import React, { useState } from 'react';
import User from '../User/User';
import styles from './header.module.css';

import alert from '../../brand/generated/header/alert.svg';

import { textStyles } from '../../constants/textStyles';

const Header = (props) => {
  return (
    <header>
      <div className={styles.title}>
        <img src={props.icon} alt="Icon" />
        <p style={textStyles.headerTitle}>{props.title}</p>
      </div>
      <div className={styles.flex}>
        <button>
          <img src={alert} alt="Alert" />
        </button>
        <User />
      </div>
    </header>
  );
};

export default Header;
